import React from 'react';

const LoadingSpinner = () => {
  return (
    <div style={{ display: 'flex', justifyContent: 'center', padding: '2rem' }}>
      <p>Loading...</p>
    </div>
  );
};

export default LoadingSpinner;